import { ChannelPreviewActionButtonsProps } from 'stream-chat-react';
import { useChannelPreviewState } from '@features/components/Chat/components/ChatContent/CustomPreviewMessenger/useChannelPreviewState';
import { ChannelStateIndicators } from '@features/components/Chat/components/ChatContent/ChannelStateIndicators';
import { StreamChannelType } from '@/api/apis/chat';

export const ChannelPreviewActionButtons = ({ channel }: ChannelPreviewActionButtonsProps) => {
  const { isPinned, isMuted } = useChannelPreviewState(channel);

  return (
    <ChannelStateIndicators isPinned={isPinned} isMuted={isMuted} channelType={channel?.type as StreamChannelType} />
  );
};
